import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Location } from '../../models/location';
import { LocationService } from '../../services/location.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Zone } from '../../models/zone';
import { ZoneService } from '../../services/zone.service';
import { State } from '../../models/state';
import { StateService } from '../../services/state.service';
import { Region } from '../../models/region';
import { RegionService } from '../../services/region.service';
import { Division } from '../../models/division';
import { DivisionService } from '../../services/division.service';
import { Cluster } from '../../models/cluster';
import { ClusterService } from '../../services/cluster.service';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerLocation: PageHeader;
  entity: Location = new Location();
  selectedLocation: Location = new Location();
  editingEntity: Location = new Location();
  locations: any;
  locationColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  company: Array<Company> = [];
  selectedCompany: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  zone: Array<Zone> = [];
  selectedZone: any;
  state: Array<State> = [];
  selectedState: any;
  region: Array<Region> = [];
  selectedRegion: any;
  division: Array<Division> = [];
  selectedDivision: any;
  cluster: Array<Cluster> = [];
  selectedCluster: any;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _locationService: LocationService,
    private _divisionService: DivisionService,
    private _clusterService: ClusterService,
    private _regionService: RegionService,
    private _companyService: CompanyService,
    private _zoneService: ZoneService,
    private _stateService: StateService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private _employeeService: EmployeeService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerLocation = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.locations = [];
    this.getAllLocation();
  }
  ngAfterViewInit(): void {
    this.locationColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "LocationName", title: 'Branch', filter: true, sortable: true, width: 150 },
      { field: "LocationCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Branch Head', filter: true, sortable: true, width: 150 },
      { field: "LocationMail", title: 'Email Id', filter: true, sortable: true, width: 100 },
      { field: "LocationPhone", title: 'Phone', filter: true, sortable: true, width: 100 },
      //{ field: "CompanyName", title: 'Company', filter: true, sortable: true },
      // { field: "ZoneName", title: 'Zone', filter: true, sortable: true },
      // { field: "StateName", title: 'State', filter: true, sortable: true },
      // { field: "RegionName", title: 'Region', filter: true, sortable: true },
      //{ field: "DivisionName", title: 'Division', filter: true, sortable: true },
      { field: "ClusterName", title: 'Cluster', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
  
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._locationService.getAllLocations('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Location>) => {
      this.locations = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }

  getAllState(filter: string) {
    this._stateService.getAllStates(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<State>) => {
      this.state = data;
    })
  }
  getAllRegion(filter: string) {
    this._regionService.getAllRegions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Region>) => {
      this.region = data;
    })
  }

  getAllDivision(filter: string) {
    this._divisionService.getAllDivisions(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Division>) => {
      this.division = data;
    })
  }

  clusterchanged(division: any) {
    this.state = [];
    this.entity.Zone_Id = '';
    this.entity.State_Id = '';
    this.selectedDivision = { Division_Id: '', Division_Name: '' };

    this.selectedRegion = { Region_Id: '', RegionName: '' };
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    this.selectedState = { State_Id: '', Zone_Name: '' };

    if (division) {
      // this.getAllState(this.entity.State_Id);
      this.getAllDivisionbyClusterId(this.entity.Cluster_Id);
      //this.getAllZone('');
    }
  }

  getAllDivisionbyClusterId(filter: string) {
    this._divisionService.getAllDivisionbyClusterId(filter).subscribe((data: Array<Division>) => {
      this.division = data;
    })

  }

  Divisionchanged(diviion: any) {
    this.state = [];
    this.entity.Zone_Id = '';
    this.entity.State_Id = '';
    this.entity.Region_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    this.selectedState = { State_Id: '', Zone_Name: '' };
    this.selectedRegion = { Region_Id: '', Region_Name: '' };
    if (diviion) {

      this.getAllregionbyDivision(diviion.Division_Id);

    }
  }

  getAllregionbyDivision(filter: string) {
    this._regionService.getAllregionbyDivision(filter).subscribe((data: Array<Region>) => {
      this.region = data;
    })

  }



  Regionchanged(region: any) {
    this.state = [];
    this.entity.Zone_Id = '';
    this.entity.State_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    this.selectedState = { State_Id: '', Zone_Name: '' };

    if (region) {
      // this.getAllState(this.entity.State_Id);
      this.getAllStatesbyRegion(region.Region_Id);
      //this.getAllZone('');
    }
  }

  getAllStatesbyRegion(filter: string) {
    this._stateService.getAllStatesbyRegion(filter).subscribe((data: Array<State>) => {
      this.state = data;
    })
    //this.selectedZone = { Zone_Id: this.state[0].Zone_Id, Zone_Name: this.state[0].ZoneName };
    //this.selectedState = { State_Id: this.state[0].State_Id, StateName: this.state[0].StateName };
    // this.getAllZone('');
    // this.getAllState('');
  }
  Statechanged(state: any) {
    this.zone = [];
    this.entity.Zone_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: '' };
    if (state) {
      // this.getAllState(this.entity.State_Id);
      this.getAllZone(this.entity.State_Id);
    }
  }
  getAllZone(filter: string) {

    this._zoneService.getAllStatesbyzone(filter).subscribe((data: Array<Zone>) => {
      this.zone = data;
    })

  }
  getallcluster(filter: string) {
    this._clusterService.getAllClusters(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Cluster>) => {
      this.cluster = data;
    })
  }
  getAllCluster(filter: string) {
    this._clusterService.getAllClusters(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Cluster>) => {
      this.cluster = data;
    })
  }
  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._locationService.getAllLocations(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((locations: Array<Location>) => {
        this.locations = {
          data: locations,
          total: locations[0] ? locations[0].TotalCount : 0
        }
      });
    }
  }
  getAllLocation() {
    this._locationService.getAllLocations('', Number(this.defaultPageSize), 1, 0, 0).subscribe((locations: Array<Location>) => {
      this.locations = {
        data: locations,
        total: locations[0] ? locations[0].TotalCount : 0
      }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._locationService.deleteLocation(this.selectedLocation.Location_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearLocation();
            this.getAllLocation();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerLocation = new PageHeader();
    headerLocation.PageCaption = "Branch";
    headerLocation.IconClass = "bi bi-shield-shaded";
    return headerLocation;
  }

  deleteLocation(event: any) {
    if (event.seletedRows[0]) {
      this.selectedLocation.Location_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Branch",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addLocation(event: any) {
    this.listView = false;
    this.clearLocation();
    this.getAllCompany('');
    this.getAllEmployees('');
    // this.getAllZone('');
    // this.getAllState('');
    // this.getAllRegion('');
    // this.getAllDivision('');
    this.getAllCluster('');
    this.formCaption = "Add Branch";
  }

  editLocation(event: any): void {
    if (event.seletedRows[0]) {
      this._locationService.viewLocation(event.seletedRows[0]).subscribe((locations: Array<Location>) => {
        let editEnity = locations[0] ? locations[0] : new Location();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          this.selectedZone = { Zone_Id: editEnity.Zone_Id, Zone_Name: editEnity.ZoneName };
          this.selectedState = { State_Id: editEnity.State_Id, State_Name: editEnity.StateName };
          this.selectedRegion = { Region_Id: editEnity.Region_Id, Region_Name: editEnity.RegionName };
          this.selectedDivision = { Division_Id: editEnity.Division_Id, Division_Name: editEnity.DivisionName };
          this.selectedCluster = { Cluster_Id: editEnity.Cluster_Id, Cluster_Name: editEnity.ClusterName };
          this.selectedRegion = { Region_Id: editEnity.Region_Id, RegionName: editEnity.RegionName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Branch";
          this.getAllCompany('');
          this.getAllEmployees('');
          this.getAllCluster('');
          this.getAllDivisionbyClusterId(this.entity.Cluster_Id);
          this.getAllregionbyDivision(this.entity.Division_Id);
          this.getAllStatesbyRegion(this.entity.Region_Id);
          this.getAllZone(this.entity.State_Id);





          this.entity.EntityMetaData = [
            { FieldName: 'LocationName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Branch Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
           // { FieldName: 'Cluster_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Cluster is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Branch Head is required' },
            // { FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            // { FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },
            // { FieldName: 'State_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State is required' },
            // { FieldName: 'Region_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region is required' },
            // { FieldName: 'Division_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Division is required' },

            { FieldName: 'LocationAddress', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Address is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    if(parseInt(this.entity.Code)==0)
    {
      this.notification.showWarning('zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._locationService.checkDuplication(this.entity.Location_Id,this.entity.Code).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Branch Code already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
            this.notification.showWarning("Invalid Phone No.");
            this.saveDisabled = false;
          }
          // const re = /^(0*[1-9]+0*)+$/;
          // const real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
          // this.codeCheck = re.test(String(this.entity.Code).toString());
          // this.codealCheck = real.test(String(this.entity.Code).toString());
          // if (this.codealCheck == false&&this.codeCheck==false ) {

          //   this.notification.showWarning("Invalid code ");
          //   this.saveDisabled = false;

          // }
          // else {
          if (this.entity.EmailId != "") {
            // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;commented on 04-06-2024 by jessil for #I238
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
            if (this.emailcheck === false) {
              this.notification.showWarning("Email not valid");
              this.saveDisabled = false;
              return
            }
          }
           
              this._locationService.checkEmail(this.entity.EmailId, this.entity.Location_Id).subscribe((response) => {
                if (response.Success == false) {
                  this.notification.showWarning("Email already exists");
                  this.saveDisabled = false;
                  return
                }
                else {
                  this._locationService.saveLocation(this.entity).subscribe(() => {
                    if (this.entity.Location_Id == '00000000-0000-0000-0000-000000000000') {
                      this.notification.showSuccess('Saved Successfully');
                    }
                    else {
                      this.notification.showSuccess('Updated Successfully');
                    }
                    this.listView = true;
                    this.clearLocation();
                    this.getAllLocation();
                  });
                }
              });
            // }
          // }
          // }
        }
      });
    }
    else {
      this.saveDisabled = false;
    }

  }
  goToBackTab(): void {

    this.listView = true;

  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllLocation();
  }

  refreshLocations(event: any): void {
    this.locations = [];
    this.getAllLocation();
  }

  clearLocation(): void {
    this.selectedCompany = {};
    this.selectedEmployee = {};
    this.selectedZone = {};
    this.selectedState = {};
    this.selectedRegion = {};
    this.selectedDivision = {};
    this.selectedCluster = {};
    this.entity = new Location();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.Location_Id=dataItem.Location_Id;
 this.details =[];
  this._locationService.viewLocation(this.entity.Location_Id).subscribe((locations: Array<Location>) => {
  this.opened = true;
   this.details = locations[0];
  })}
}
